/**
 * Enumeration of all webshop events
 */
export enum WebshopEvent {
    /** Represents the Welcome event */
    Welcome = "welcome",
};
